export const reviews = [
  {
    body: 'Le sedute con il dottor Jacopo sono un vero toccasana. Sa ascoltare, comprendere e trovare una via anche quando i pensieri si affollano e si intrigano. Il suo supporto si rinnova sempre prezioso e confortevole.',
    author: 'GP',
  },
  {
    body: 'Posso affermare che disponibilità, cortesia e attenzione nell\'ascolto non mancano mai durante i colloqui.',
    author: 'DV',
  },
  {
    body: 'Sono davvero contento di aver trovato Jacopo come psicologo. Bravissimo, cortese, disponibile e sempre pronto ad ascoltarti.',
    author: 'SM',
  },
  {
    body: 'Dottore attento, intuitivo e gentile. Ha ascoltato ogni singola parola da me detta e nonostante fosse la prima visita mi ha già dato tanti spunti su cui riflettere. Abbiamo dato inizio a un percorso che sono certo porterà a grandi risultati.',
    author: 'Carlo',
  },
  {
    body: 'I have started seeing Doctor Biraschi almost 4 months ago and since have already made big steps. His therapy approach is on point and has helped me realized so many things about myself. Our sessions are in English (not my first language, but it\'s actually not an issue, even around more subtle topics). I highly recommend him.',
    author: 'Eleonora',
  },
  {
    body: 'Il Dott. Biraschi mi ha suscitato subito fiducia, soprattutto grazie al suo approccio giovane e "smart", empatico e competente. Penso di non poter desiderare psicoterapeuta migliore!',
  },
];
